<script lang="ts" setup>
const props = defineProps({
  color: {
    type: String,
    default: '#2c2f39',
    required: false,
  },
})
</script>

<template>
  <svg width="7" height="12" viewBox="0 0 6 10" :fill="color">
    <path
      d="M5.69308 5.5309L1.44194 9.74643C1.28213 9.90491 1.05838 10 0.866601 10C0.67482 10 0.483039 9.90491 0.323222 9.74643C0.00358748 9.42948 0.00358748 8.98574 0.323222 8.66878L4.03098 4.99208L0.323222 1.31537C0.00358748 0.998416 0.00358748 0.554675 0.323222 0.237718C0.642856 -0.0792389 1.12231 -0.0792389 1.44194 0.237718L5.69308 4.45325C5.8529 4.61173 5.91683 4.8019 5.91683 4.99208C5.91683 5.21395 5.8529 5.37243 5.69308 5.5309Z"
      :fill="props.color"
    />
  </svg>
</template>
